<template>
<svg data-cy="c-clube-logo" enable-background="new 0 0 1920 1080" version="1.1" :class="classes" viewBox="0 0 1920 1080" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
  <g id="svg_1">
   <g id="svg_2">
    <g id="svg_3">
     <polygon id="svg_4" fill="#202950" points="755.5,472.4250030517578 675.2000122070312,472.4250030517578 605.7000122070312,561.7250061035156 605.7000122070312,383.5250053405762 539.2000122070312,383.5250053405762 539.2000122070312,703.5249938964844 605.7000122070312,703.5249938964844 605.7000122070312,611.125 679.7000122070312,703.5249938964844 758.2000122070312,703.5249938964844 662.5,586.625 " class="st0"/>
     <path id="svg_5" fill="#202950" d="m925.1,491.32501c-17.3,-16.7 -40,-25.1 -67.8,-25.1c-30.8,0 -57.5,11.9 -79.5,35.4c-21.9,23.4 -33,52.5 -33,86.4s11.1,63 33,86.4c22,23.5 48.7,35.4 79.5,35.4c27.8,0 50.5,-8.4 67.8,-25.1l0,18.9l66.4,0l0,-231.2l-66.4,0l0,18.9zm-16.2,54.8c10.9,10.9 16.2,24.6 16.2,41.8c0,17.3 -5.3,30.9 -16.2,41.8c-10.9,10.9 -24.3,16.2 -41,16.2c-16.7,0 -30,-5.3 -40.7,-16.2l0,0c-10.8,-10.9 -16,-24.6 -16,-41.9c0,-17.3 5.2,-31 16,-41.9c10.8,-10.9 24.1,-16.2 40.7,-16.2c16.7,0.2 30.1,5.5 41,16.4z" class="st0"/>
     <rect id="svg_6" fill="#202950" height="333.3" width="66.4" class="st0" y="370.22501" x="1034.4"/>
     <path id="svg_7" fill="#202950" d="m1254.4,466.12501c-35.5,0 -64.9,11.7 -87.6,34.9c-22.7,23.1 -34.2,52.4 -34.2,86.9c0,34.8 11.7,64.2 34.6,87.2c23,23 53.8,34.6 91.6,34.6c44,0 77.9,-16.7 100.6,-49.5l2.8,-4.1l-54,-31.1l-2.4,3.2c-10.4,13.7 -25.5,20.4 -46.1,20.4c-29.5,0 -48,-10.7 -56.3,-32.6l165,0l0.7,-3.8c1.5,-8.5 2.3,-16.7 2.3,-24.3c0,-34.2 -11.1,-63.3 -33,-86.6c-22.1,-23.3 -50.3,-35.2 -84,-35.2zm-35.4,71.5c9.2,-7.2 21.1,-10.8 35.4,-10.8c12,0 22.8,3.4 32.2,10.2c8,5.8 13.7,14.3 17,25.5l-101.4,0c3.3,-10.4 8.9,-18.8 16.8,-24.9z" class="st0"/>
     <path id="svg_8" fill="#202950" d="m1577.8,491.22501c-17,-16.6 -39.6,-25 -67.4,-25c-31.1,0 -58,11.9 -79.9,35.4c-21.9,23.4 -33,52.5 -33,86.4s11.1,63 33,86.4c22,23.5 48.9,35.4 79.9,35.4c27.7,0 50.3,-8.4 67.4,-25l0,18.8l66.4,0l0,-320l-66.4,0l0,107.6zm-56.7,154.8c-16.7,0 -30.1,-5.3 -41,-16.2c-10.9,-10.9 -16.2,-24.6 -16.2,-41.8c0,-17.3 5.3,-30.9 16.2,-41.8c10.9,-10.9 24.3,-16.2 41,-16.2c16.6,0 30,5.3 40.7,16.2c10.8,10.9 16,24.6 16,41.9c0,17.3 -5.2,31 -16,41.9c-10.8,10.7 -24.1,16 -40.7,16z" class="st0"/>
     <path id="svg_9" fill="#202950" d="m1884.5,501.42501c-23.6,-23.4 -52.8,-35.3 -86.7,-35.3c-34,0 -63.1,11.9 -86.5,35.3c-23.4,23.4 -35.3,52.5 -35.3,86.5s11.9,63.1 35.3,86.5c23.4,23.4 52.5,35.3 86.5,35.3c34,0 63.1,-11.9 86.7,-35.3l0,0c23.6,-23.4 35.5,-52.5 35.5,-86.5c0,-33.9 -12,-63 -35.5,-86.5zm-30.9,86.6c0,16.7 -5.2,30 -16,40.7c-10.8,10.8 -23.8,16 -39.8,16c-16.1,0 -29,-5.2 -39.6,-16c-10.6,-10.8 -15.8,-24.1 -15.8,-40.8s5.2,-30 15.8,-40.8c10.6,-10.7 23.5,-16 39.6,-16c16.1,0 29.1,5.2 39.8,16c10.7,10.9 16,24.2 16,40.9z" class="st0"/>
    </g>
   </g>
   <g id="svg_10">
    <path id="svg_11" fill="#202950" d="m103.9,332.22501c-57.4,0 -103.9,46.5 -103.9,103.9l0,207.8c0,57.4 46.5,103.9 103.9,103.9s103.9,-46.5 103.9,-103.9l0,-207.8c0,-57.4 -46.5,-103.9 -103.9,-103.9zm43,311.7c0,23.8 -19.3,43 -43,43c-23.8,0 -43,-19.3 -43,-43l0,-207.8c0,-23.8 19.3,-43 43,-43c23.8,0 43,19.3 43,43l0,207.8z" class="st0"/>
    <path id="svg_12" fill="#202950" d="m385.1,362.62501c-40.6,-40.6 -106.4,-40.6 -146.9,0l-207.8,207.8c-40.6,40.6 -40.6,106.4 0,146.9s106.4,40.6 146.9,0l207.8,-207.8c40.6,-40.5 40.6,-106.3 0,-146.9zm-250.8,311.7c-16.8,16.8 -44.1,16.8 -60.9,0c-16.8,-16.8 -16.8,-44.1 0,-60.9l207.8,-207.7c16.8,-16.8 44.1,-16.8 60.9,0c16.8,16.8 16.8,44.1 0,60.9l-207.8,207.7z" class="st0"/>
    <path id="svg_13" fill="#202950" d="m311.7,540.02501c-57.4,0 -103.9,46.5 -103.9,103.9s46.5,103.9 103.9,103.9s103.9,-46.5 103.9,-103.9s-46.5,-103.9 -103.9,-103.9zm0,146.9c-23.8,0 -43,-19.3 -43,-43c0,-23.8 19.3,-43 43,-43c23.8,0 43,19.3 43,43c0,23.8 -19.2,43 -43,43z" class="st0"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  props: {
    isWhite: Boolean,
    isGrey: Boolean
  },
  computed: {
    classes () {
      return [ 'c-clube-logo', {
        '-grey': this.isGrey,
        '-white': this.isWhite
      }]
    }
  }
}
</script>

<style lang="scss">

.c-clube-logo {
  .st0{fill:#121E48;}
  .st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#XMLID_141_);}
  .st2{display:none;}
  .st3{display:inline;}
  .st4{fill:#FFFFFF;}
  .st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#XMLID_142_);}
  .st6{fill:#7873EE;}
  .st7{fill-rule:evenodd;clip-rule:evenodd;fill:#7873EE;}
  .st8{fill:#BE4DF7;}
  .st9{fill-rule:evenodd;clip-rule:evenodd;fill:#BE4DF7;}
  .st10{fill-rule:evenodd;clip-rule:evenodd;fill:#121E48;}
  .st11{fill-rule:evenodd;clip-rule:evenodd;}
  .st12{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
  .st13{fill:#444242;}
  .st14{fill-rule:evenodd;clip-rule:evenodd;fill:#87868A;}

  &.-white {
    .st0,
    .st1 { fill: #fff; stroke: #fff; }
  }

  &.-grey {
    .st0,
    .st1 { fill: rgba(169, 180, 193, 1); stroke: rgba(169, 180, 193, 1); }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/CComponents/CClubeLogo.vue